import ProjectViews from "../../project-views"
import ProjectView from "../../project-view"
import {ViewType} from "../../../../gd/const/views/view-type"
import {ProjectAccess} from "../../../../gd/const/project"
import projectViews_getCRMSettings from "./get-crm-settings"

// @ts-ignore
import OrganizationSettingsManager from "../../../../gd/manager/organization-settings-manager"
import ProjectSession from "../../../project/project-session";

// const debug = "projectViews_shouldProjectViewBeRemoved"
const debug = false

export default function projectViews_shouldProjectViewBeRemoved(projectViews: ProjectViews, projectView: ProjectView) {
    // access check
    if (projectView.access === 'private' && projectView.userId !== gd.user.id) return true

    debug && console.log(debug, 'process', gd.user.isCustomer(), projectViews.project.access, projectViews_isViewSystemTypeAvailable(projectView.systemType, projectViews.project))

    if (!projectViews_isViewSystemTypeAvailable(projectView.systemType, projectViews.project)) return true

    // for customers skip all views that are not in projectViews CRM settings of project
    // if projectViews are null then all views are available
    if (gd.user.isCustomer() || projectViews.project.access === ProjectAccess.CLIENT) {
        if (!showForCustomer(projectViews, projectView)) return true
    } else if (projectViews.project.access === ProjectAccess.LIMITED) {
        if (!showForLimited(projectView)) return true
    }

    debug && console.log(debug, 'process [view remains]', projectView)

    return false
}

export function projectViews_isViewSystemTypeAvailable(systemType: ViewType, project: ProjectSession) {
    debug && console.log(debug, 'projectViews_isViewSystemTypeAvailable', systemType, project)

    switch (systemType) {
        case ViewType.PROJECT_FILES:
            // prevent files projectView when files disabled
            return OrganizationSettingsManager.isAttachmentsEnabled()

        case ViewType.PROJECT_DOCS:
            // disable Docs for template
            return !project.isTemplate

        case ViewType.PROJECT_DISCUSSION:
            // disable Discussions if chat module turned off
            return gd.modules.chats.enabled

        case ViewType.PROJECT_MEETINGS:
            // disable Meetings if meetings module turned off
            return gd.modules.meetings.enabled

        case ViewType.PROJECT_GOALS:
            // disable Goals if goals module turned off
            return gd.modules.goals.enabled

        case ViewType.MY_ATTENDANCE:
            // disable Attendance if clock module turned off
            return gd.modules.clockInOut.enabled
    }

    return true
}

function showForCustomer(projectViews: ProjectViews, projectView: ProjectView) {
    let res = true

    const crmSettings = projectViews_getCRMSettings(projectViews.project)

    // customers have 'Read Only + Comment' access level but custom projectViews access
    if (!!crmSettings.projectViews) {
        // if viewId is among crmSettings.projectViews then this view should be displayed for customer
        res = !!_.find(crmSettings.projectViews, viewId=>{
            const id = viewId?.toString() /*in case of old number format present*/
            return id === projectView.id
        })
    }

    return res
}

function showForLimited(projectView: ProjectView) {
    let res = true

    // no WORKLOAD/GANTT/FILES/NOTES views for limited access users
    if ([
        ViewType.PROJECT_WORKLOAD,
        ViewType.PROJECT_GANTT,
        ViewType.PROJECT_FILES,
        // ViewType.PROJECT_DOCS,
        ViewType.PROJECT_ACTIVITY,
        ViewType.PROJECT_EXPENSES,
    ].includes(projectView.systemType as ViewType)) {
        res = false
    }

    return res
}